module.exports = __webpack_public_path__ + "media/Cairo.68994171.ogg";